export default async () => {
  const { language } = window.navigator;

  try {
    return (await import(`system/i18n/${language.toLowerCase()}`)).default;
  } catch (e) {
    return (await import('system/i18n/en-us')).default;
  }
};

export const Brands = {
  bottomline: {
    brand: 'Bottomline',
    brandPtx: 'Bottomline PTX',
    ptxLink: 'PTX Link',
    ptx: 'PTX'
  },
  lloyds: {
    brand: 'Lloyds',
    brandPtx: 'Lloyds',
    ptxLink: 'Lloyds Link',
    ptx: 'Lloyds'
  }
};